import styled from "styled-components";
import { Text, ComponentStack } from "@components";

export const SourceOfFundsContainer = styled(ComponentStack)`
  align-items: center;
`;
